import SvgArrowRight from '@unifyapps/icons/outline/ArrowRight';
import Stack from '../../../_components/Stack';
import { FeaturedIcon } from '../../FeaturedIcon';
import { Link } from '../../Link';
import { Pill } from '../../Pill';
import type { EmptyStateStatusProps } from '../types';
import { containerVariants, titleVariants } from '../styles';
import EmptyStateTitle from '../components/EmptyStateTitle';
import EmptyStateDescription from '../components/EmptyStateDescription';

const labelTypography = { weight: 'regular' as const, variant: 'text-xs' as const };

function EmptyStateStatus(props: EmptyStateStatusProps) {
  const { title, Icon, variant, description, descriptionNode, learnMore, infoMessage } = props;
  const containerClassName = containerVariants({ variant });
  const titleClassName = titleVariants({ variant });

  return (
    <Stack
      alignItems="start"
      className={containerClassName}
      direction="column"
      justifyContent="center"
    >
      {Icon ? <FeaturedIcon Icon={Icon} color="gray" size="sm" /> : null}
      <Stack className="gap-y-xs items-start">
        <Stack>
          <EmptyStateTitle className={titleClassName} title={title} />
          {description ? <EmptyStateDescription description={description} /> : descriptionNode}
        </Stack>
        {learnMore ? (
          <Link
            className="font-semibold"
            color="brand"
            href={learnMore.href}
            size="sm"
            target="_blank"
          >
            {learnMore.label}
          </Link>
        ) : null}
      </Stack>
      <Stack className="gap-x-md" direction="row">
        <Stack alignItems="center" className="gap-x-md" direction="row">
          <Pill
            className="border-none !px-0"
            color="gray"
            label="Status"
            labelTypography={labelTypography}
            shape="square"
            variant="clear"
          />
          <SvgArrowRight className="h-4 w-4" />
        </Stack>
        {infoMessage}
      </Stack>
    </Stack>
  );
}

export default EmptyStateStatus;
